import styled from 'styled-components'

export const Style = styled.div`
  .border {
    display: flex;
    justify-content: center;
  }
  .title-body-one {
    text-align: center;
    display: block;
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    background: linear-gradient(to top, #e8dce1, rgba(227, 239, 249, 0));
    .title-one {
      text-align: left;
    }
    .title-body-one {
      text-align: left;
    }
    .border {
      display: flex;
      justify-content: flex-start;
    }
  }
  .column-fix-margin {
    margin-bottom: 24px;
    margin-top: 55px;
  }
  .bottom-margin {
    margin-bottom: 20px;
  }
  .top-margin {
    margin-top: 16px;
  }
`
